import React, { useEffect } from 'react';

import { DashboardButton } from './Success.styled';
import { PurchaseConfirmation } from 'screens/Book/steps/Success/PurchaseConfirmation/PurchaseConfirmation';

import { Props } from './Success.types';
import { getAppointmentName } from './Success.utils';

export const SuccessStep = ({
  appointmentType,
  selectedAppointmentTypes,
  selectedProduct,
  purchasedProduct,
  partnerClinicSelected
}: Props): JSX.Element => {
  const appointmentName = getAppointmentName(
    selectedProduct,
    selectedAppointmentTypes,
    appointmentType
  );

  useEffect(() => {
    localStorage.setItem('BOOKING_SUCCEEDED', 'true');
  }, []);

  return (
    <>
      <PurchaseConfirmation
        purchase={purchasedProduct}
        partnerClinicDetails={partnerClinicSelected}
        appointmentName={appointmentName}
      />
      <DashboardButton
        href="/"
        onClick={() => {
          if (localStorage.getItem('BOOKING_SUCCEEDED') !== null) {
            localStorage.removeItem('BOOKING_SUCCEEDED');
          }
        }}
      >
        Go To Dashboard
      </DashboardButton>
    </>
  );
};
